import { translationsNext } from './actionTypes';
import enUsBaselineTranslations from '../../../config/translations/EN-CA.json';

const baselineTranslationsByLanguage = {
  'EN-CA': enUsBaselineTranslations,
};

const getBaselineTranslations = (language) => {
  if (!language) {
    return {};
  }

  const baseline = baselineTranslationsByLanguage[language];
  if (!baseline) {
    return {};
  }

  return baseline.translations || baseline;
};

const defaultState = {
  isLoading: true,
  texts: {},
  languages: {}
};

export const i18n = (state = defaultState, { type, payload, actionData }) => {
  switch (type) {
    case translationsNext.INIT:
      return {
        ...state,
        isLoading: true,
      };
    case translationsNext.ERROR:
      return {
        ...state,
        isLoading: false,
      };
    case translationsNext.SUCCESS:
      {
        const baselineTranslations = getBaselineTranslations(actionData?.language);
        const serverTranslations = (payload || {}).translations || {};
        return {
          ...state,
          texts: {
            ...baselineTranslations,
            ...serverTranslations,
          },
          languages: (payload || {}).languages || {},
          isLoading: false,
        };
      }
    default:
      return state;
  }
};
